namespace RioERP.Web.Enums {
    export enum TaxApplicable {
        No = 0,
        Yes = 1
    }
    Serenity.Decorators.registerEnumType(TaxApplicable, 'RioERP.Web.Enums.TaxApplicable');
}
